/**
 * Dashboard › Users (PRIVATE fork) — read-only list + detail over
 * letpot-api /admin/user via @greenhouse/crud.
 */

import { useMemo } from 'react';
import { defineCrud, CrudPage } from '@greenhouse/crud';
import { Users } from '../../../lib/icons';
import { letpotDataSource } from '../../../lib/dashboard/data-source';

interface UserRow {
  _id: string;
  email: string;
  nickname: string;
  country: string;
  city: string;
  device_count: number;
  message_count: number;
  diary_count: number;
  created_at: string;
  last_login_at: string;
}

const dataSource = letpotDataSource<UserRow>('user');

export function DashboardUsers() {
  const schema = useMemo(
    () =>
      defineCrud<UserRow>({
        name: 'User',
        icon: Users,
        idField: '_id',
        dataSource,
        defaultSort: { key: 'created_at', order: 'desc' },
        columns: [
          { key: 'email', label: 'Email', sortable: true },
          { key: 'nickname', label: 'Nickname', responsiveHide: 'md' },
          { key: 'country', label: 'Country', width: '7rem', responsiveHide: 'md' },
          { key: 'device_count', label: 'Devices', type: 'number', align: 'right', responsiveHide: 'lg' },
          { key: 'diary_count', label: 'Diaries', type: 'number', align: 'right', responsiveHide: 'lg' },
          { key: 'created_at', label: 'Registered', type: 'date', sortable: true, responsiveHide: 'md' },
          { key: 'city', label: 'City', hidden: true },
          { key: 'message_count', label: 'Messages', type: 'number', hidden: true },
          { key: 'last_login_at', label: 'Last login', type: 'datetime', hidden: true },
        ],
        filters: [
          { key: 'email', label: 'Search email', kind: 'text' },
          { key: 'country', label: 'Country', kind: 'text', secondary: true },
        ],
        detailTabs: [{ key: 'all', label: 'Profile', kind: 'fields' }],
        access: { canView: true },
      }),
    [],
  );
  return <CrudPage schema={schema} />;
}
